const ADD_SUPER_OFFERS = 'ADD_SUPER_OFFERS';
const TOGGLE_SUPER_OFFERS = 'TOGGLE_SUPER_OFFERS';

const toggleSuperOffers = ({ offerId, isFavourite }) => ({
  type: TOGGLE_SUPER_OFFERS,
  payload: {
    offerId,
    isFavourite
  }
});

const setSuperOffers = superOffers => ({
  type: ADD_SUPER_OFFERS,
  payload: {
    superOffers
  }
});

export {
  ADD_SUPER_OFFERS, TOGGLE_SUPER_OFFERS, setSuperOffers, toggleSuperOffers
};
